import Vue from 'vue'
import Vuex from 'vuex'
import global from './modules/global'
import { Dialog } from 'mand-mobile'
import i18n from '@/lang'
import common from './modules/common'
import getters from './getters'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    addClass: false,
    activeVisible: false,
    kycVisible: false,
    agreementVisible: false,
    addCardVisible: false,
    errorVisible: false,
    accountVisible: false,
    name: '',
    noAppVisible: false
  },
  mutations: {
    change_addClass: (state, payload) => {
      state.addClass = payload
    },
    change_activeVisible: (state, payload) => {
      if (state.common.certificateLevel.faceAuditStatus) { // 人工审核时
        Dialog.alert({
          content: i18n.t('2025072420995_564a65ad'),
          confirmText: i18n.t('i_know'), // 我知道了
          onConfirm: () => console.log('[Dialog.alert] confirm clicked')
        })
        return
      }
      // 判断账户有没有激活的弹窗
      state.activeVisible = payload
    },
    change_kycVisible: (state, payload) => {
      // 高级实名认证
      state.kycVisible = payload
    },
    change_agreementVisible: (state, payload) => {
      const { faceAuditStatus, actived } = state.common.certificateLevel
      if (faceAuditStatus) { // 人工审核时
        Dialog.alert({
          content: i18n.t('2025072420995_564a65ad'),
          confirmText: i18n.t('i_know'), // 我知道了
          onConfirm: () => console.log('[Dialog.alert] confirm clicked')
        })
        return
      }
      // 实名认证协议 面部识别不超过5次 没有激活 不再人工审核中
      if (!actived && !faceAuditStatus) {
        state.agreementVisible = payload
      }
    },
    change_addCardVisible: (state, payload) => {
      // 添加绑定卡
      state.addCardVisible = payload
    },
    change_errorVisible: (state, payload) => {
      // 账户异常
      state.errorVisible = payload
    },
    change_name: (state, payload) => {
      // 未绑卡 用来判断是充值 还是 提现
      state.name = payload
    },
    change_noAppVisible: (state, payload) => {
      // 不是从app进入页面
      state.noAppVisible = payload
    },
    change_accountVisible: (state, payload) => {
      state.accountVisible = payload
    }
  },
  getters,
  actions: {
  },
  modules: {
    common,
    global
  }
})
